import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { messages } from '../messages';

import style from '../manage-add-ons.module.less';

const AddOnDescriptionColumnId = 'addOnDescription';

const addOnDescriptionBuilder = ({ content }) => {
  return content.description;
};

const AddOnDescriptionCell = ({ cell }) => {
  return <Text className={style['add-on-description']} textType={TextType.Paragraph} value={cell.value} />;
};

AddOnDescriptionCell.propTypes = {
  cell: PropTypes.shape({
    value: PropTypes.string,
  }).isRequired,
};

const createAddOnDescriptionColumnDefinition = createColumnDefinitionBuilder({
  Header: <FormattedMessage {...messages.description} />,
  accessor: AddOnDescriptionColumnId,
  Cell: AddOnDescriptionCell,
  width: 3,
  className: style['justify-end'],
});

export { AddOnDescriptionColumnId, addOnDescriptionBuilder, createAddOnDescriptionColumnDefinition };
